(async function () {
	const helpers = {
	  trimTrailingSlash(pathname) {
		return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
	  },
	  saveReturnUrl() {
		sessionStorage.setItem(RETURN_PATH_KEY, window.location.href);
	  },
	  removeSavedUrl() {
		sessionStorage.removeItem(RETURN_PATH_KEY);
	  },
	  hydrateReturnUrl() {
		const savedReturnUrl = sessionStorage.getItem(RETURN_PATH_KEY) || window.origin;
		const searchParams = new URLSearchParams(window.location.search);
  
		const logoutConfirmed = searchParams.get('done') === 'true';
		const loginCancelled = searchParams.get('error') === 'access_denied';
  
		helpers.removeSavedUrl();
  
		if (savedReturnUrl.includes('/ecare') && (logoutConfirmed || loginCancelled)) {
		  const redirectUrl = new URL(window.origin);
		  redirectUrl.pathname = savedReturnUrl.includes('/ar') ? '/ar' : '';
  
		  return (window.location = redirectUrl.toString());
		}
  
		window.location = savedReturnUrl;
	  },
	};
  
	const RETURN_PATH_KEY = 'corpp:return-path';
  
	const { UserManager, WebStorageStateStore } = window.Oidc;
	const { oidc_config } = window.login;
  
	const oidcInstance = new UserManager({
	  authority: oidc_config.authority,
	  client_id: oidc_config.client_id,
	  redirect_uri: oidc_config.redirect_uri,
	  response_type: 'code',
	  scope: 'openid CHANNEL_WEB',
	  userStore: new WebStorageStateStore({ store: window.localStorage }),
	  post_logout_redirect_uri: oidc_config.post_logout_redirect_uri,
	  automaticSilentRenew: true,
	  silent_redirect_uri: oidc_config.silent_redirect_uri,
	  loadUserInfo: false,
	  staleStateAge: 3600,
	  stopCheckSessionOnError: false,
	  // accessTokenExpiringNotificationTime: 1790, // fast silent refresh
	});
  
	// #######################
	// ### handle auth endings
	// #######################
  
	const url = new URL(window.location.href);
	const currentUrl = helpers.trimTrailingSlash(`${url.origin}${url.pathname}`);
  
	if (currentUrl === oidc_config.silent_redirect_uri) {
	  await oidcInstance.signinSilentCallback();
	  return;
	}
  
	if (currentUrl === oidc_config.redirect_uri) {
	  await oidcInstance.signinRedirectCallback().catch(() => {});
	  helpers.hydrateReturnUrl();
	  return;
	}
  
	if (currentUrl === oidc_config.post_logout_redirect_uri) {
	  helpers.hydrateReturnUrl();
	  return;
	}
  
	// #######################
	// ### setup DOM listeners
	// #######################
  
	oidcInstance.clearStaleState();
  
	const signin = async () => {
	  helpers.saveReturnUrl();
	  await oidcInstance.signinRedirect({ extraQueryParams: { lng: oidc_config.lang } });
	};
  
	const signout = async () => {
	  helpers.saveReturnUrl();
	  await oidcInstance
		.getUser()
		.then(user => {
		  return user.expired ? oidcInstance.signinSilent() : Promise.resolve();
		})
		.then(() => oidcInstance.signoutRedirect({ extraQueryParams: { lng: oidc_config.lang } }))
		.catch(() => {
		  renderUserStatus(false);
		  helpers.removeSavedUrl();
		});
	};
  
	const header = document.querySelector('header#main-header');
  
	const renderUserStatus = loggedIn => {
	  if (loggedIn) {
		return header.classList.add('logged');
	  }
  
	  header.classList.remove('logged');
	};
  
	const mobileBtnLogin = header.querySelector('button#login-mobile');
	const mobileBtnLogout = header.querySelector('button#logout-mobile');
  
	const desktopBtnLogin = header.querySelector('button#login-desktop');
	const desktopBtnLogout = header.querySelector('button#logout-desktop');
  
	mobileBtnLogin.addEventListener('click', () => signin());
	mobileBtnLogout.addEventListener('click', () => signout());
  
	desktopBtnLogin.addEventListener('click', () => signin());
	desktopBtnLogout.addEventListener('click', () => signout());
  
	oidcInstance.events.addUserSignedOut(async () => {
	  oidcInstance
		.signinSilent()
		.then(() => renderUserStatus(true))
		.catch(async error => {
		  if (error && error.error === 'login_required') {
			await oidcInstance.removeUser();
			return renderUserStatus(false);
		  }
		});
	});
  
	oidcInstance
	  .signinSilent()
	  .then(() => renderUserStatus(true))
	  .catch(error => {
		if (error && error.error === 'login_required') {
		  return renderUserStatus(false);
		}
	  });
  
	const user = await oidcInstance.getUser();
  
	if (!user) {
	  return renderUserStatus(false);
	}
  
	if (user.expired) {
	  return renderUserStatus(false);
	}
  
	renderUserStatus(true);
  })();